import React, { useEffect, useState } from "react";
import Button from "@material-ui/core/Button";
import Dialog from "@material-ui/core/Dialog";
import DialogContent from "@material-ui/core/DialogContent";
import DialogContentText from "@material-ui/core/DialogContentText";
import DialogTitle from "@material-ui/core/DialogTitle";
import {
  Grid,
  Box
} from "@material-ui/core";
import { useForm, FormContext, Controller } from "react-hook-form";
import { default as Apiservices } from "./common";

export default function IdleLogoutPopup(props) {
  const methods = useForm();
  useEffect(() => { }, []);

  const CancelPopup = () => {
    props.updateLogout()
    const token = sessionStorage.getItem("token")
    const resp = Apiservices.resetLogin({ token })
    props.closeConfirmationPopup();
  };

  const IdleLogout = async () => {
    props.Logout();
    props.closeConfirmationPopup();
  };

  return (
    <FormContext {...methods}>
      <form key={true} id="create-pda"></form>
      <React.Fragment>
        <Dialog
          open={true}
          onClose={CancelPopup}
          fullWidth={true}
          maxWidth={"md"}
          aria-labelledby="responsive-dialog-title"
        >
          <DialogTitle id="responsive-dialog-title"></DialogTitle>
          <DialogContent>
            <DialogContentText id="responsive-dialog-title">
              <Box width={"100%"}>
                {`Screen is Idle for one hour.Do you want to Logout?`}
                <Box py={5}>
                  <Grid container spacing={2} justifyContent="center">
                    <Grid item>
                      <Button
                        onClick={() => IdleLogout()}
                        disabled={false}
                        color="primary"
                        variant="contained"
                        className="btnMinWidthSearch"
                      >
                        Yes
                      </Button>
                    </Grid>
                    <Grid item>
                      <Button
                        onClick={() => CancelPopup()}
                        disabled={false}
                        color="primary"
                        variant="contained"
                        className="btnMinWidthSearch"
                      >
                        No
                      </Button>
                    </Grid>
                  </Grid>
                </Box>
              </Box>
            </DialogContentText>
          </DialogContent>
        </Dialog>
      </React.Fragment>
    </FormContext>
  );
}
